export const customFieldFilterKeys = {
    all: ['custom-field-filter'] as const,
    byField: (customFieldId: string) => [...customFieldFilterKeys.all, customFieldId] as const,
};
